import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectChannelThemes } from "containers/ChannelsPage/selectors";
import {
  StyledFilterPreview,
  FilterPreviewShadow,
  PreviewFilter,
  PreviewFilterLogoWrapper,
} from "../styledComponents";
import { Embellishment } from "containers/ChannelsPage/Forms/components";

import {
  placeholder,
  classic,
  boomerang,
  still,
  storyVideo,
  standard,
  blackAndWhite,
  glitch,
} from "components/DevicePreview";

const PhotoFilterPreview = ({
  small,
  med,
  placeholderSrc,
  themes,
  selectedTheme,
  themeInstance,
  firstLine,
  secondLine,
  withGraphic,
  withFilter,
  noMargin,
  center,
  photoOptions,
  photoFilters,
}) => {
  const themeId = themeInstance && themeInstance.channel_theme_id;
  const theme = selectedTheme || themes[themeId];
  const firstLineSize = theme && theme.first_line_max_size;
  const secondLineSize = theme && theme.second_line_max_size;
  const defaultFirstLine = theme && theme.default_first_line_text;
  const defaultSecondLine = theme && theme.default_second_line_text;
  const photoFilterUrl = theme && theme.photo_filter_preview_url;
  const font = theme && theme.font;
  const maxFontWidth = theme && theme.max_text_width;
  const embellishmentPosition = theme && theme.embellishment_position;
  const lineHeight = theme && theme.line_height;
  const secondLineFont = theme && theme.second_line_font;
  const secondLineLetterSpacing = theme && theme.second_line_letter_spacing;
  const isBehindText = embellishmentPosition === "behind_text";
  const backgroundUrl = isBehindText && photoFilterUrl;
  var photoImageSource = "";
  if (photoOptions) {
    switch (photoOptions) {
      case "4pose":
        photoImageSource = classic;
        break;
      case "tnb":
        photoImageSource = boomerang;
        break;
      case "still":
        photoImageSource = still;
        break;
      case "video":
        photoImageSource = storyVideo;
        break;
      case "standard":
        photoImageSource = standard;
        break;
      case "bnw":
        photoImageSource = blackAndWhite;
        break;
      case "glitch":
        photoImageSource = glitch;
        break;
    }
  }

  const previewStyle = {
    backgroundRepeat: ["no-repeat", "no-repeat"],
    backgroundSize: ["contain", "cover"],
    backgroundImage: [
      `url(${!isBehindText && withFilter && withGraphic && photoFilterUrl})`,
      `url(${
        photoOptions && photoImageSource ? photoImageSource : placeholder
      })`,
    ],
    backgroundPosition: [embellishmentPosition, "center"],
  };

  if (photoFilters && Array.isArray(photoFilters) && photoFilters.length > 0) {
    var filterSrc = [];
    photoFilters.map((src) => {
      src && filterSrc.push(`url(${src})`);
    });
    previewStyle.backgroundImage.unshift(filterSrc);
  }

  const embellishmentProps = {
    font,
    firstLineSize,
    maxFontWidth,
    firstLine,
    defaultFirstLine,
    secondLineSize,
    secondLine,
    defaultSecondLine,
    backgroundUrl,
    lineHeight,
    secondLineFont,
    secondLineLetterSpacing,
    withoutFilter: !withFilter,
  };

  return (
    <StyledFilterPreview
      small={small}
      med={med}
      noMargin={noMargin}
      center={center}
    >
      <PreviewFilter style={previewStyle}>
        <PreviewFilterLogoWrapper isBehindText={isBehindText}>
          <Embellishment {...embellishmentProps} />
        </PreviewFilterLogoWrapper>
      </PreviewFilter>
      <FilterPreviewShadow></FilterPreviewShadow>
    </StyledFilterPreview>
  );
};

const mapStateToProps = createStructuredSelector({
  themes: selectChannelThemes(),
});

export default connect(mapStateToProps)(PhotoFilterPreview);
